import { Route, Routes } from "react-router-dom";
import { PageNotFound } from "../commons/PageNotFound.js";
import { OrganisationPublicProfile } from "./OrganisationPublicProfile.js";

export const OrganisationPublicRoutes = () => {
  return (
    <Routes>
      <Route path=":slug" element={<OrganisationPublicProfile />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};
